import { Networks } from "./blockchain";

const MATIC_MAINNET = {
    MASTER_MANTIS_ADDRESS: "0x2c1Ded27522E317515e5B5e856De7293938b6D1E",
    POOL_ADDRESS: "0x62Ba5e1AB1fa304687f132f67E35bFC5247166aD",
    MNT_ADDRESS: "0xE92175Ea10FC1F59F633c77153e81780A6EEaE04",
    VEMNT_ADDRESS: "0xBb919023638201BfA66157A7EBA6302795A3DDD4",
    ASSET_USDC_ADDRESS: "0xe03aec0d08B3158350a9aB99f6Cea7bA9513B889",
    ASSET_USDT_ADDRESS: "0xe8A1eAD2F4c454e319b76fA3325B754C47Ce1820",
    ASSET_DAI_ADDRESS: "0x4b3BFcaa4F8BD4A276B81C110640dA634723e64B",
    USDC_ADDRESS: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
    USDT_ADDRESS: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    DAI_ADDRESS: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
    AIRDROP_ADDRESS: "0x2AdeDCfD726e03032dDEf1241D5C8eFAd40C1F80",
};

const ZK_MAINNET = {
    MASTER_MANTIS_ADDRESS: "0x10CA56461E7fff96785e1BdDA3dA3361b1c135C9",
    POOL_ADDRESS: "0x9A368Ea1A23198E718c99fE316A4f913f2867e12",
    MNT_ADDRESS: "0xa338591D89305d1Dd85df5e6454A3aa2d17342A4",
    VEMNT_ADDRESS: "0x21e0462986d095351213298b7DE1D96e0eC24A84",
    ASSET_USDC_ADDRESS: "0xA50F9053bF192b49Ec7244a5566ef5B08cAaa4E3",
    ASSET_USDT_ADDRESS: "0x22F3157B3571CBA039219aAA1fc0899668022347",
    ASSET_DAI_ADDRESS: "0x82Ab73E225095c53C83DbFe612f19E1cd331E62E",
    USDC_ADDRESS: "0x59CAcD93925766283Fa660c554a6425a80d23083",
    USDT_ADDRESS: "0x361e0B6043EBdD2Bb551D6Ebc8b24486906A3116",
    DAI_ADDRESS: "0x8AaD0f1EFfDaa0493e5E5d047B2603999077b873",
    AIRDROP_ADDRESS: "",
};

export const getAddresses = (networkID: number) => {
    if (networkID === Networks.MATIC) return MATIC_MAINNET;
    if (networkID === Networks.ZK) return ZK_MAINNET;

    throw Error("Network don't support");
};
